var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2275 69H32.97V75H72.2275V69Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2275 57H32.97V63H72.2275V57Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2275 45H32.97V51H72.2275V45Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102H42C30.42 102 21 92.58 21 81V25.4575L31.1525 17.1375L38.26 23.11L45.385 17.105L52.5175 23.1L59.6425 17.095L66.775 23.09L73.9 17.085L84.035 25.605V90.0025C84.035 91.605 84.6575 93.1125 85.79 94.245C86.9225 95.3775 88.43 96.0025 90.0325 96.0025H93.0025C96.31 96.0025 99.0025 93.31 99.0025 90.0025V78.0025H90.0025V72.0025H105.003V90.0025C105.003 96.62 99.62 102.003 93.0025 102.003L93 102ZM26.9975 28.2975V81C26.9975 89.27 33.7275 96 42 96H79.6325C78.5875 94.195 78.03 92.14 78.03 90V28.3975L73.9025 24.9275L66.78 30.9325L59.6475 24.9375L52.5225 30.9425L45.39 24.9475L38.265 30.9525L31.105 24.935L27 28.3L26.9975 28.2975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/Bill.f32a74d6.svg";
export { ForwardRef as ReactComponent };